// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { TipoArticuloApiInputProps, TipoArticuloProps } from '../interfaces'
import { tipoArticuloFragment } from '../interfaces/tipoArticuloFragment'

const gqlQuery = gql`
  ${tipoArticuloFragment}
  mutation TIPO_ARTICULO_REGISTRO($codigo: String!, $input: TipoArticuloInput!) {
    tipoArticuloRegistro(codigo: $codigo, input: $input) {
      ...tipoArticuloFragment
    }
  }
`

/**
 * Registramos un nuevo tipo de articulo
 * @param codigo
 * @param input
 */
export const apiTipoArticuloRegistro = async (
  codigo: string | null,
  input: TipoArticuloApiInputProps,
): Promise<TipoArticuloProps> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)
    const data: any = await client.request(gqlQuery, {
      codigo: codigo,
      input: input,
    })
    return data.tipoArticuloRegistro
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
